import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewServiceSiteComponent } from './new-service-site.component';
import { DxAutocompleteModule, DxButtonModule, DxSelectBoxModule, 
  DxScrollViewModule,
    DxTabPanelModule,
    DxAccordionModule,
    DxDateBoxModule,
    DxTagBoxModule,
    DxRangeSliderModule,
    DxFileUploaderModule,
    DxNumberBoxModule,
    DxToolbarModule,DxTextBoxModule, DxCheckBoxModule, DxTextAreaModule, DxDataGridModule, DxSliderModule, DxPopupModule, DxTemplateModule, DxDropDownButtonModule } from 'devextreme-angular';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { NewCustomerModule } from '../new-customer/new-customer.module';



@NgModule({
  declarations: [
    NewServiceSiteComponent
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxButtonModule,
    DxAutocompleteModule,
    GooglePlaceModule,
    DxCheckBoxModule,
    NewCustomerModule,
    DxTextAreaModule,
    DxDataGridModule,
    DxSliderModule,
    DxButtonModule,
    DxPopupModule,
    DxTemplateModule,
    DxDropDownButtonModule,
    DxScrollViewModule,
    DxTabPanelModule,
    DxAccordionModule,
    DxDateBoxModule,
    DxTagBoxModule,
    DxRangeSliderModule,
    DxFileUploaderModule,
    DxNumberBoxModule,
    DxToolbarModule
  ],
  exports: [NewServiceSiteComponent]
})
export class NewServiceSiteModule { }
